export default {
  errors: null,
  fees: [],
  loading: false,
  count: 0,
  totalCount: 0
};
